/**
 * Directiva utilizada para ver y añadir comentarios a las tareas
 */
InputComentarioDirectiva.$inject = [];
export default function InputComentarioDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'tareaId': '@',
            'mensaje': '=',
            'usuariosParaCitar': '=usuarios',
            'urlSearch': '@?'
        },
        template: require('./input-comentario.html'),
        controller: 'InputComentarioCtrl as inpComent',
        bindToController: true
    }
}